import { useEffect, useState } from "react";
import { fetchActiveAnnouncement } from "@/lib/api";
import { Megaphone, X } from "lucide-react";

// Sitewide banner — dismissible per-session via sessionStorage
export default function AnnouncementBanner() {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetchActiveAnnouncement().then(setAnn).catch(() => {});
  }, []);

  useEffect(() => {
    if (!ann) return;
    const key = `noxi_dismiss_${ann.announcement_id}`;
    if (sessionStorage.getItem(key)) setDismissed(true);
  }, [ann]);

  if (!ann || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(`noxi_dismiss_${ann.announcement_id}`, "1");
    setDismissed(true);
  };

  return (
    <div data-testid="announcement-banner" className="bg-primary text-primary-foreground border-b-2 border-foreground">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-2.5 flex items-center gap-3 text-sm">
        <Megaphone className="w-4 h-4 flex-shrink-0" strokeWidth={2}/>
        <div className="flex-1 font-medium">{ann.text}</div>
        <button data-testid="announcement-dismiss" onClick={dismiss} className="p-1 hover:bg-foreground/10">
          <X className="w-3.5 h-3.5"/>
        </button>
      </div>
    </div>
  );
}
